/* eslint-disable no-useless-escape */
import { mobileRegExpUS, telephoneRegExpUS } from "./RegularExpressions";

/**
 * 
 * @param phoneNumber string of phone number
 * @returns boolean
 * @description Validates US MObile and Telephone Numbers
 */
export const validatePhoneNumber = (phoneNumber: string):boolean => {
    // Check if the input matches either the telephone or mobile regex
    return telephoneRegExpUS.test(phoneNumber) || mobileRegExpUS.test(phoneNumber);
}
/**
 * 
 * @param num number | float | double
 * @returns number
 * @description takes a number and returns a 2 decimal point rounded number.
 */
export const roundToDecimal2 = (num: number) => {
    return Math.round((num + Number.EPSILON) * 100) / 100
}

/**
 * 
 * @param num number | float | double
 * @returns number
 * @description takes a number as input and returns rounded value to closest integer.
 */
export const roundToNearestInteger = (num: number) => {
    return Math.round(num);
}

/**
 * 
 * @param arr Array[number]
 * @returns number
 * @description takes an array of numbers  as input and returns sum or values.
 */
export const arraySum = (arr: Array<number>): number => {
    return arr.reduce((acc, op) => acc + op, 0);
}

/**
 * 
 * @param arr Array[number]
 * @returns number
 * @description returns average of array of type number.
 */
export const arrayAverage = (arr: Array<number>) => {
    return arr.reduce((acc, op) => acc + op, 0 ) / arr.length;
}

/**
 * 
 * @param timestamp number
 * @returns 
 * @description takes unix time stamp as input and returns a rounded value to nearest hour in time
 */
export const roundToNearestHour = (timestamp: number): number => {
    const date = new Date(timestamp * 1000);
    const minutes = date.getMinutes();
    date.setMinutes(minutes >= 30 ? 0 : 60);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return Math.floor(date.getTime() / 1000);
}

/**
 * 
 * @param seconds number
 * @param setSeconds callback
 * @param setIsSendCode callback
 * @param maxWaitTime number
 * @description
 */
export const sendCodeTimer = (seconds: number, setSeconds: React.Dispatch<React.SetStateAction<number>>, setIsSendCode: React.Dispatch<React.SetStateAction<boolean>>, maxWaitTime: number = 60) => {
    setIsSendCode(true);
    let countSeconds = seconds;
    let tempTimer: any = 0;
    if (tempTimer === 0 && countSeconds > 0){
        tempTimer = setInterval(()=>{
        countSeconds = countSeconds - 1;
        setSeconds(countSeconds);
            if (countSeconds === 0) {
                clearInterval(tempTimer);
                setIsSendCode(false);
                setSeconds(maxWaitTime);
            }
        },1000);
    }
}